import clsx from "clsx";
import { cn } from "@/core/helpers/cn";
import { DoorHangerIcon, LockIcon, LockOpenIcon } from "@/shared/icons";
import { Checkbox } from "@/shared/ui";

type Props = {
  id: number;
  checked: boolean;
  onChange?: (id: number) => void;
  text: string;
  disabled: boolean;
  hasOwner: boolean;
  isMyRoom: boolean;
  className?: string;
};

export default function HotelRoomCkeckbox({
  id,
  checked,
  onChange,
  text,
  disabled,
  hasOwner,
  isMyRoom,
  className,
}: Props) {
  return (
    <div className={cn("relative flex items-center gap-2 w-13.5", className)}>
      <Checkbox
        checked={checked}
        onChange={() => onChange(id)}
        variant="variant-4"
        isDisabled={disabled}
      />
      <button
        className={clsx(
          "group flex items-center gap-1.5 text-14 font-bold leading-none transition-all ease-in-out duration-200",
          disabled && !checked && "pointer-events-none text-white/20",
          (checked || isMyRoom) && "text-[#84FF97]",
          !disabled && "hover:text-[#84FF97]",
        )}
        type="button"
        onClick={() => onChange(id)}
      >
        <p className="min-w-6.5">{text}</p>
        {isMyRoom && <DoorHangerIcon className="size-5 text-[#84FF97]" />}
        {disabled && hasOwner && <LockIcon className="size-5 text-accent-solid" />}
        {disabled && !hasOwner && <DoorHangerIcon className="size-5 text-white/10" />}
        {!disabled && !isMyRoom && (
          <LockOpenIcon
            className={clsx(
              "size-5 group-hover:text-[#84FF97]",
              checked ? "text-[#84FF97]" : "text-white",
            )}
          />
        )}
      </button>
    </div>
  );
}
